export default __webpack_public_path__ + "static/wespeed-0e808d87553d8d5f66137f00195e64e7.png";